<template>
  <div id="app">
    <password-check v-if="showCheckPassword"></password-check>
    <router-view />
    
    <!-- <invite-form></invite-form> -->
    <loading-util></loading-util>
    <option-config-util></option-config-util>
    <!-- <div class="time">{{time}} {{userInfo && userInfo.nickName}}</div> -->
    <help-window v-if="helpBoxStatus"></help-window>
    <message-util :state="showMessageBox" :messageInfo="messageInfo"></message-util>
    <el-dialog :visible="missionBoxStatus" title="任务详情快捷窗口" @close="initMissionBox">
      <mission-publish :task-id="missionTaskId" :msg-id="missionMsgId" @close="initMissionBox"></mission-publish>
    </el-dialog>
  </div>
</template>

<script>
import OptionConfigUtil from '@/components/Util/OptionConfigUtil'
import TopMenu from '@/components/TopMenu'
import InviteForm from '@/components/Setting/InviteForm'
import {mapMutations, mapState, mapActions} from 'vuex'
import LoadingUtil from '@/components/Util/LoadingUtil'
import HelpWindow from '@/components/Setting/HelpWindow'
import MessageUtil from '@/components/Util/MessageUtil'
import MissionPublish from '@/components/AccAutomatic/MissionPublish'
import PasswordCheck from '@/components/Account/passwordCheck.vue'
export default {
  name: 'App',
  data() {
    return {
      time: ''
    }
  },
  created() {
    this.initRequestEvent()
    // this.initTimeInterval()
    this.getMenuList()
    if(!location.href.includes('login') && localStorage.getItem('token')) {
      this.setImportantMessage()
      this.setMessageTimer()
      // this.setMissionPublish()
    }
  },
  mounted() {
    this.getConfigDom()
    this.getPermissionConfig()
  },
  methods: {
    ...mapMutations(['refreshLoadingState','initShowMessageStatus','setMessageTimer','getConfigDom','setMissionPublish','initMissionBox']),
    ...mapActions(['getMenuList','setImportantMessage','getPermissionConfig']),
    initTimeInterval() {
      setInterval(() => {
        const date = new Date()
        this.time = `${date.getMonth()+1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
      },1000)
    },
    initRequestEvent() {
      const that = this
      window.$request = {
        _state: false,
        get state() {
          return this._state
        },
        set state(nV) {
          this._state = nV
          if(nV) {
            that.refreshLoadingState(true)
          }else {
            that.refreshLoadingState(false)
          }
        }
      }
    },
  },
  computed: {
    ...mapState(['userInfo','missionBoxStatus','missionTaskId','missionMsgId','showCheckPassword']),
    helpBoxStatus(){
      return this.$store.state.HelpCenter.helpBoxStatus
    },
    showMessageBox() {
      return this.$store.state.Message.showMessageBox
    },
    messageInfo() {
      return this.$store.state.Message.messageInfo
    },
  },
  components: {
    TopMenu,
    InviteForm,
    LoadingUtil,
    OptionConfigUtil,
    HelpWindow,
    MessageUtil,
    MissionPublish,
    PasswordCheck,
  }
}
</script>

<style lang="scss" scoped>
#app {
  .time {
    position: fixed;
    z-index: 99999;
    color: red;
    font-size: 12px;
    top: 20px;
    left: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue